import { render, staticRenderFns } from "./StepByStepNavigation.vue?vue&type=template&id=1c90b572&"
import script from "./StepByStepNavigation.vue?vue&type=script&lang=js&"
export * from "./StepByStepNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c90b572')) {
      api.createRecord('1c90b572', component.options)
    } else {
      api.reload('1c90b572', component.options)
    }
    module.hot.accept("./StepByStepNavigation.vue?vue&type=template&id=1c90b572&", function () {
      api.rerender('1c90b572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/category/StepByStepNavigation.vue"
export default component.exports